import { render } from "./ViewAssignment.vue?vue&type=template&id=7bc77610&scoped=true"
import script from "./ViewAssignment.vue?vue&type=script&lang=js"
export * from "./ViewAssignment.vue?vue&type=script&lang=js"

import "./ViewAssignment.vue?vue&type=style&index=0&id=7bc77610&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc77610"]])

export default __exports__